<template>
  <main-layout
    class="aviatFarming"
    page-title="航育自动生成农事对接"
    custom-back
    @listen-back="goBack"
  >
    <div slot="main-content" class="aviatFarming-content">
      <!-- 页面头部 -->
      <div class="aviatFarming-header">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="待审核" name="first"></el-tab-pane>
        </el-tabs>
        <div class="aviatFarming-header-txt">
          审核后的数据可通过
          <span @click="goArigicRecordPage">【农事记录】</span>
          中查看
        </div>
      </div>
      <div class="aviatFarming-box" v-if="activeName === 'first'">
        <!-- 筛选条件 -->
        <div class="aviatFarming-form">
          <div class="aviatFarming-form-div">
            <el-input
              v-model="queryForm.chargeUserName"
              size="medium"
              placeholder="请输入操作人搜索"
              @input="handleChange"
            >
            </el-input>
          </div>
          <div class="aviatFarming-form-div">
            <el-select
              v-model="queryForm.sysMissionCategoryId"
              size="medium"
              placeholder="全部农事类型"
              @change="handleChange"
            >
              <el-option
                v-for="item in missionCategoryList"
                :label="item.sysMissionCategoryName"
                :value="item.sysMissionCategoryId"
                :key="item.sysMissionCategoryId"
              ></el-option>
            </el-select>
          </div>
          <div class="aviatFarming-form-div aviatFarming-form-date">
            <el-date-picker
              v-model="queryForm.date"
              size="medium"
              type="daterange"
              :clearable="false"
              :picker-options="pickerDateOptions"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="handleChange"
            >
            </el-date-picker>
          </div>
          <div class="aviatFarming-form-btn">
            <el-button
              size="medium"
              type="primary"
              v-if="isShowAutoExamine"
              :disabled="!dataList.length || !multipleSelection.length"
              @click="autoReview(7)"
              >7天自动审核</el-button
            >
            <el-button
              size="medium"
              type="primary"
              v-if="isShowAutoExamine"
              :disabled="!dataList.length || !multipleSelection.length"
              @click="autoReview(3)"
              >3天自动审核</el-button
            >
            <!-- <el-button
              size="medium"
              class="export-btn"
              v-if="isShowExport"
              :disabled="!dataList.length || !multipleSelection.length"
              >导出</el-button
            > -->
          </div>
        </div>
        <!-- 列表 -->
        <TableList
          ref="tabList"
          class="tablelist"
          :is-show="!!dataList.length"
          :list="dataList"
          :loading="tableLoading"
          @selectListChange="selectListChange"
          @updateList="updateList"
        >
        </TableList>
        <!-- 分页 -->
        <pagiation
          :total="total"
          :pageSize="queryForm.pageSize"
          :pageNo="queryForm.pageNo"
          @currentChange="currentChange"
          :pagisShow="!!dataList.length"
          v-show="!!dataList.length"
        />
      </div>
      <!-- 全选、批量操作 -->
      <div class="aviatFarming-footer-tools">
        <div>
          <el-checkbox
            size="medium"
            v-model="checkAll"
            :disabled="!dataList.length"
            @change="handleCheckAllChange"
          >
            全选
            <span v-if="checkAll">{{ multipleSelection.length }}条</span>
            <span v-if="isIndeterminate"
              >选中{{ multipleSelection.length }}条</span
            >
          </el-checkbox>
          <el-button
            round
            size="mini"
            v-if="isShowBatchExamine"
            :disabled="!dataList.length"
            @click="batchReview"
            >批量审核</el-button
          >
          <el-button
            round
            size="mini"
            v-if="isShowBatchDel"
            :disabled="!dataList.length"
            @click="batchDelete"
            >批量删除</el-button
          >
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import TableList from "./TableList/Index";
import Pagiation from "@/components/Pagiation.vue";
import { windowHref } from "@/utils";
import { getStorage } from "@/utils/storage";
import { mapActions } from "vuex";
import {
  getMissionCategoryList,
  getMissionList,
  getAutoAuditByDay,
  getBatchDel,
  getBatchAudit,
} from "@/api/request/snkd.produce";

export default {
  name: "AviatFarmingList",
  components: {
    MainLayout,
    TableList,
    Pagiation,
  },

  data() {
    return {
      activeName: "first",
      tableLoading: false,
      companyId: "",
      farmId: "",
      queryForm: {
        chargeUserName: "",
        sysMissionCategoryId: "",
        date: [],
        pageNo: 1,
        pageSize: 20,
      },
      total: 0,
      missionCategoryList: [
        {
          sysMissionCategoryId: "",
          sysMissionCategoryName: "全部农事类型",
        },
      ], // 农事类型
      dataList: [],
      checkAll: false,
      isIndeterminate: false,
      multipleSelection: [], //表格勾选的数据
      //是否显示7天、3天自动审核按钮
      isShowAutoExamine: false,
      //是否显示导出按钮
      isShowExport: false,

      //是否显示批量删除按钮
      isShowBatchDel: false,
      //是否显示批量审核按钮
      isShowBatchExamine: false,
      pickerDateOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  async mounted() {
    //初始化时间
    let startDate =
      new Date().getFullYear() + "-" + new Date().format("MM") + "-01";
    let endDate = new Date().format("yyyy-MM-dd");
    this.queryForm.date = [startDate, endDate];

    //获取农场id
    const farminfo = getStorage("FARMINFO");
    if (getStorage("FARMINFO")) {
      this.companyId = farminfo.companyId;
      this.farmId = farminfo.farmId;
    }
    await this.fnHasPermission();
    await this.getTypeList();
    await this.getList();
  },
  methods: {
    ...mapActions("permission", ["hasPermission"]),
    async getList() {
      this.tableLoading = true;
      let params = {
        ...this.queryForm,
        companyId: this.companyId,
        farmId: this.farmId,
        startTime: this.queryForm.date ? this.queryForm.date[0] : "",
        endTime: this.queryForm.date ? this.queryForm.date[1] : "",
      };

      await getMissionList(params).then((res) => {
        const { respCode, obj } = res;
        if (respCode === 0) {
          this.dataList = obj.list || [];
          this.total = obj.totalCount;
        }
        this.tableLoading = false;
      });
    },
    async getTypeList() {
      await getMissionCategoryList().then((res) => {
        const { respCode, obj } = res;
        if (respCode === 0) {
          let arr = obj || [];
          this.missionCategoryList.push(...arr);
        }
      });
    },
    //更新列表
    updateList() {
      this.queryForm.pageNo = 1;
      this.getList();
    },
    //判断按钮是否有权限
    async fnHasPermission() {
      //自动审核
      this.isShowAutoExamine = await this.hasPermission(
        "produce:navigateCultivate:autoExamine"
      );
      //导出
      this.isShowExport = await this.hasPermission(
        "produce:navigateCultivate:export"
      );
      //批量删除
      this.isShowBatchDel = await this.hasPermission(
        "produce:navigateCultivate:batchDel"
      );
      //批量审核
      this.isShowBatchExamine = await this.hasPermission(
        "produce:navigateCultivate:batchExamine"
      );
    },
    //批量审核
    batchReview() {
      if (!this.multipleSelection.length) {
        this.$message({
          type: "info",
          message: "请勾选数据后再进行批量操作",
        });
        return false;
      }
      const h = this.$createElement;
      this.$confirm("", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "confirm-dialog",
        message: h("div", [
          h(
            "p",
            {
              style:
                "font-size: 16px;margin-bottom:12px;color: rgba(0, 0, 0, 0.85);font-weight:400;",
            },
            `是否进行批量审核？`
          ),
          h(
            "p",
            {
              style:
                "font-size: 14px;color: rgba(0, 0, 0, 0.65);font-weight:400;",
            },
            [
              h("span", null, "已选中"),
              h(
                "i",
                { style: "color: #FF0000" },
                `${this.multipleSelection.length}`
              ),
              h("span", null, "条数据，审核后的数据可在"),
              h(
                "i",
                {
                  style: "color: #21C074;cursor:pointer",
                  on: {
                    click: () => {
                      console.log("lllllll");
                      // 回到农事记录页
                      this.goArigicRecordPage();
                    },
                  },
                },
                `【农事记录】`
              ),
              h("span", null, "中查看。"),
            ]
          ),
        ]),
        type: "warning",
      })
        .then(async () => {
          await getBatchAudit({
            idList: this.multipleSelection.map((item) => item.id),
          }).then((res) => {
            const { respCode } = res;
            if (respCode === 0) {
              this.$message({
                type: "success",
                message: "批量审核成功！",
              });
            } else if (respCode === 40012) {
              this.auditFail();
            }
            //失败成功都更新列表
            this.queryForm.pageNo = 1;
            this.getList();
          });
        })
        .catch(() => {});
    },
    //批量删除
    batchDelete() {
      if (!this.multipleSelection.length) {
        this.$message({
          type: "info",
          message: "请勾选数据后再进行批量操作",
        });
        return false;
      }
      const h = this.$createElement;
      this.$confirm("", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "confirm-dialog",
        message: h("div", [
          h(
            "p",
            {
              style:
                "font-size: 16px;margin-bottom:12px;color: rgba(0, 0, 0, 0.85);font-weight:400;",
            },
            `是否进行批量删除？`
          ),
          h(
            "p",
            {
              style:
                "font-size: 14px;color: rgba(0, 0, 0, 0.65);font-weight:400;",
            },
            [
              h("span", null, "已选中"),
              h(
                "i",
                { style: "color: #FF0000" },
                `${this.multipleSelection.length}`
              ),
              h("span", null, "条数据，删除后的数据将无法恢复。"),
            ]
          ),
        ]),
        type: "warning",
      })
        .then(async () => {
          await getBatchDel({
            idList: this.multipleSelection.map((item) => item.id),
          }).then((res) => {
            const { respCode } = res;
            if (respCode === 0) {
              this.$message({
                type: "success",
                message: "批量删除成功！",
              });
              this.queryForm.pageNo = 1;
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
    // 自动审核
    autoReview(type) {
      const h = this.$createElement;
      this.$confirm("", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "confirm-dialog",
        message: h("div", [
          h(
            "p",
            {
              style:
                "font-size: 16px;margin-bottom:12px;color: rgba(0, 0, 0, 0.85);font-weight:400;",
            },
            `确认设置${type}天自动审核吗?`
          ),
          h(
            "p",
            {
              style:
                "font-size: 14px;color: rgba(0, 0, 0, 0.65);font-weight:400;",
            },
            [
              h("span", null, "确定后将按照农事创建时间进行"),
              h("i", { style: "color: #FF0000" }, `${type}天后`),
              h("span", null, "自动审核成功。"),
            ]
          ),
          h(
            "p",
            {
              style:
                "font-size: 14px;color: rgba(0, 0, 0, 0.65);font-weight:400;line-height:26px",
            },
            type === 3
              ? "注：如当前数据已符合农事创建时间3天后审核的条件，确定后将自动审核成功"
              : ""
          ),
        ]),
        type: "warning",
      })
        .then(() => {
          //审核
          this.antuAudit(type);
        })
        .catch(() => {});
    },
    //7天、3天自动审核
    async antuAudit(type) {
      try {
        let params = {
          auditType: type === 3 ? 0 : 1,
          idList: this.multipleSelection.map((item) => item.id),
        };
        await getAutoAuditByDay(params).then((res) => {
          const { respCode } = res;
          if (respCode === 0) {
            this.$message({
              type: "success",
              message: `已成功设置${type}天自动审核!`,
            });
            this.queryForm.pageNo = 1;
            this.getList();
          } else if (respCode === 40012) {
            // 审核不成功
            this.auditFail();
            this.queryForm.pageNo = 1;
            this.getList();
          }
        });
      } catch (err) {
        console.log("err", err);
      }
    },
    auditFail() {
      const h = this.$createElement;
      this.$confirm("", {
        confirmButtonText: "知道了",
        showCancelButton: false,
        customClass: "confirm-dialog",
        message: h("div", [
          h(
            "p",
            {
              style:
                "font-size: 16px;margin-bottom:12px;color: rgba(0, 0, 0, 0.85);font-weight:400;",
            },
            `审核未通过！`
          ),
          h(
            "p",
            {
              style:
                "font-size: 14px;color: rgba(0, 0, 0, 0.65);font-weight:400;",
            },
            [h("span", null, "当前数据未审核成功，请手动重新审核。")]
          ),
        ]),
        type: "warning",
      })
        .then(() => {
          this.isIndeterminate = false;
          this.checkAll = false;
          this.multipleSelection = [];
          this.$refs.tabList.$refs.multipleTable.clearSelection();
        })
        .catch(() => {});
    },
    // 全选按钮切换
    handleCheckAllChange(val) {
      console.log("handleCheckAllChange", val, this.$refs.tabList);
      if (val) {
        //全选当前页
        this.$refs.tabList.$refs.multipleTable.toggleAllSelection();
      } else {
        //清空当前页选择数据
        this.$refs.tabList.$refs.multipleTable.clearSelection();
      }
      this.isIndeterminate = false;
    },
    // 表格选中数据切换
    selectListChange(rows) {
      this.multipleSelection = rows;
      let checkedLength = rows.length;
      this.checkAll = checkedLength === this.dataList.length;
      this.isIndeterminate =
        checkedLength > 0 && checkedLength < this.dataList.length;
    },
    // 页码切换
    currentChange(pageNo) {
      this.isIndeterminate = false;
      this.checkAll = false;
      this.multipleSelection = [];
      this.$refs.tabList.$refs.multipleTable.clearSelection();
      this.queryForm.pageNo = pageNo;
      this.getList();
    },
    handleChange() {
      if (this.queryForm.date) {
        let startTime = new Date(this.queryForm.date[0]).getTime();
        let endTime = new Date(this.queryForm.date[1]).getTime();
        if (endTime - startTime > 31536000000) {
          this.$message({
            message: "起始日期和结束日期不能超过一年",
            type: "warning",
          });
          this.dataList = [];
          return false;
        }
      }
      this.queryForm.pageNo = 1;
      this.getList();
    },
    goBack() {
      windowHref("/home/home");
    },
    goArigicRecordPage() {
      // windowHref("/home/batch", {
      //   companyId: this.companyId,
      //   farmId: this.farmId,
      //   tab: 1,
      //   periodType: 2,
      //   source: "hangyu",
      // });
      window.open(
        window.location.origin +
          `/index.html#/home/batch/company=${this.companyId}&farm=${this.farmId}&tab=1&periodType=2&source=hangyu`
      );
    },
    //tab切换
    handleClick() {},
  },
};
</script>

<style scoped lang="scss">
.aviatFarming {
  .aviatFarming-content {
    width: 1320px;
    height: 100%;
    background: #fff;
    margin: 0 auto;
    ::v-deep .aviatFarming-header {
      height: 68px;
      position: relative;
      .el-tabs,
      .el-tabs__header,
      .el-tabs__nav-wrap,
      .el-tabs__nav-scroll,
      .el-tabs__nav,
      .el-tabs__item {
        height: 100%;
        line-height: 68px;
      }
      .el-tabs__nav-scroll {
        padding-left: 20px;
      }
      .el-tabs__item {
        font-size: 22px;
        font-weight: 700;
      }
      &-txt {
        position: absolute;
        top: 28px;
        right: 37px;
        font-size: 12px;
        color: #000;
        font-weight: 400;
        cursor: pointer;
        span {
          color: #21c074;
        }
      }
    }
    .aviatFarming-box {
      .aviatFarming-form {
        padding: 32px 12px;
        display: flex;
        &-div {
          width: 180px;
          margin-left: 10px;
        }
        &-date {
          width: 250px;
          .el-date-editor {
            width: 100%;
          }
        }
        &-btn {
          flex: 1;
          text-align: right;
          .export-btn {
            border: 1px solid #64c3a4;
            color: #64c3a4;
          }
        }
      }
    }
    .aviatFarming-footer-tools {
      width: 100%;
      padding: 10px 14px;
      position: fixed;
      bottom: 0;
      left: 0;
      background: #fff;
      z-index: 2;
      > div {
        width: 1300px;
        margin: 0 auto;
      }
      .el-button {
        margin-left: 24px;
      }
    }
  }
}

::v-deep .el-table {
  height: 100%;
  .el-table__body-wrapper {
    position: relative;
    height: calc(100% - 80px);
    table {
      padding-bottom: 0 !important;
    }
  }
  .el-table__header-wrapper {
    th:first-child {
      .cell {
        width: 60px;
        .el-checkbox {
          display: none;
        }
        &:after {
          // content:'';
        }
      }
    }
  }
}
::v-deep .el-table {
  border: 0;
  th,
  tr,
  td {
    border: 0;
  }
  &::before {
    height: 0px;
  }
}
// 表格行样式
::v-deep .statistics-warning-row {
  background: $--color-tablist;
}

// 滚动条样式
::v-deep .bscroll-indicator {
  background-color: #dcdfe6 !important;
}
::v-deep .bscroll-vertical-scrollbar {
  z-index: 1 !important;
}

//表头高度
::v-deep .el-table__header tr,
.el-table__header th {
  height: 60px;
}
// 行背景色
::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fff !important;
}

::v-deep .el-table__row {
  height: 62px;
}
::v-deep .el-table td,
.el-table th.is-leaf {
  border: none;
}
// 表格最外边框
.el-table--border,
.el-table--group {
  border: none;
}
// 加载圈
::v-deep .el-loading-mask {
  z-index: 1;
}
</style>

<style lang="scss">
.confirm-dialog .el-message-box__status.el-icon-warning {
  top: 13px !important;
}
.confirm-dialog {
  width: 450px;
}
</style>
